/**
 * Consistent outlined fields with labels above the input edge (not mixed
 * placeholder-style vs floating behavior).
 */
const textField = {
  defaultProps: {
    variant: "outlined",
    InputLabelProps: { shrink: true },
  },
};

export default textField;
